import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'store';
import ChatToolsVerticalRail from './ChatToolsVerticalRail';
import { isChatToolsDockedPanelId } from './chat-tools-rail-ids';
import { CHAT_OUTLET_TO_FLOATING_RAIL_SPACING } from './layout-zoom-constants';

/**
 * רייל פקודה צף גלובלי על אזור הצ'אט המרכזי + מרווח לתוכן שלא ייחתך תחת הרייל.
 * כשפאנל הכלים ממסילה פתוח — הרייל מוצג בתוך המגירה (Dock) ולא כאן.
 */
const ChatFloatingCommandRailLayout: React.FC = () => {
  const theme = useTheme();
  const location = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isBotBuilderComponentSettings = useSelector(
    (s) => s.dualSidebar.right.activeId === 'bot-builder-component-settings',
  );
  const { open, chatPanelStyle, activeId } = useSelector((s) => s.dualSidebar.right);
  const railDockedInDrawer =
    open && Boolean(chatPanelStyle && activeId && isChatToolsDockedPanelId(activeId));

  const showRail =
    location.pathname.startsWith('/chats') && !isMobile && !isBotBuilderComponentSettings;

  const duration = theme.transitions.duration.shorter + 200;

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        minWidth: 0,
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'stretch',
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          flex: '1 1 0%',
          minHeight: 0,
          minWidth: 0,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration,
          }),
          boxSizing: 'border-box',
        }}
      >
        <Outlet />
      </Box>
      {showRail && !railDockedInDrawer ? (
        <Box
          sx={{
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            alignSelf: 'stretch',
            pointerEvents: 'none',
            marginInlineStart: (t) => t.spacing(CHAT_OUTLET_TO_FLOATING_RAIL_SPACING),
            '& > *': { pointerEvents: 'auto' },
          }}
        >
          <ChatToolsVerticalRail />
        </Box>
      ) : null}
    </Box>
  );
};

export default ChatFloatingCommandRailLayout;
